import { useOrgInfo, useUserInfo } from "@src/common/reliablePartnerApi";
import { RPFormattedMessage } from "@src/i18n";

const LK2Info = () => {
  const orgInfo = useOrgInfo();
  const userInfo = useUserInfo();

  if (!userInfo.isSuccess || !orgInfo.isSuccess) {
    console.log(userInfo.isSuccess, orgInfo.isSuccess);
    return null;
  }

  console.log(
    orgInfo.data?.role,
    userInfo.data?.isAdmin,
    orgInfo.data?.country
  );
  if (
    (orgInfo.data?.role === "main" ||
      userInfo.data?.isAdmin ||
      orgInfo.data?.role === "basic") &&
    orgInfo.data?.country === "FI"
  ) {
    return (
      <div
        className="alert alert-success mt-4"
        id="admin-notification-lk2-info"
      >
        <i
          className="fa fa-info-circle mr-4 align-self-center"
          aria-hidden="true"
        ></i>
        <RPFormattedMessage
          id="adminNotificationLk2Info"
          defaultMessage="<b>Uusi kattavampi versio.</b> Luotettavasta Kumppanista on nyt saatavilla lisähintaan. Kerro yrityksesi kokonaistilasta - esim. taloudesta, vastuuhenkilöistä ja vastuullisuudesta - entistä laajemmin ja läpinäkyvämmin. <linkToLk2Service>Lue lisää ja päivitä</linkToLk2Service>"
        />
      </div>
    );
  } else {
    return null;
  }
};

export default LK2Info;
